import { useEffect, useState } from "react";
import { unsubscribeNewsletter } from "../api/newslettersApi";

export default function Unsubscribe() {
  const [token, setToken] = useState(null);
  const [message, setMessage] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  // Get token from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get("token"); // JWT or subscriber token
    setToken(tokenFromUrl);
  }, []);

  const handleConfirm = async () => {
    if (!token) return;

    try {
      const res = await unsubscribeNewsletter(token); // API call
      setMessage(res.message || "You have been unsubscribed successfully.");
      setConfirmed(true);
    } catch (err) {
      console.error(err);
      setMessage(err.error || "Something went wrong. Please try again later.");
    }
  };

  // Invalid token case
  if (!token) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-purple-500 to-indigo-600 p-4">
        <div className="bg-white rounded-xl shadow-xl p-8 max-w-md text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Invalid Link
          </h2>
          <p className="text-gray-600">
            The unsubscribe link you followed is invalid or expired.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-purple-500 to-indigo-600 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-12 max-w-md w-full text-center animate-fade-in">
        {!confirmed ? (
          <>
            <h2 className="text-3xl font-extrabold text-gray-800 mb-6">
              Confirm Unsubscribe
            </h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to unsubscribe from our newsletter? You will
              no longer receive updates from us.
            </p>
            <button
              onClick={handleConfirm}
              className="px-6 py-3 bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-semibold rounded-xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl focus:outline-none"
            >
              Yes, Unsubscribe
            </button>
          </>
        ) : (
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Unsubscribed
            </h2>
            <p className="text-gray-600">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
}
